import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const NUMBERS_ITEM_OPTION = () => ({
  description: 'Descrição',
  number: '10'
})

export const NUMBERS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'numbers',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA(),
    subtitle: SUBTITLE_SCHEMA(),
    bg: BG_SCHEMA(),
    items: [NUMBERS_ITEM_OPTION()],
    'accent-color': '#202020',
    'max-columns': 4
  }
}

export const beforeParseNumbers = target => {
  commonBeforeParseMethod(target)
}

export const NUMBERS_SECTION = config => ({
  schema: NUMBERS_SCHEMA(config),
  beforeParse: beforeParseNumbers
})
